import { Icon, type IconProps } from './PlatformIcons.tsx';

/**
 * Le due icone che sostituiscono le iniziali: profilo dell'utente ed ente.
 *
 * Non un'etichetta in più: sono `aria-hidden` di suo (le porta `Icon`, come
 * ogni altra icona del progetto) e il nome per esteso resta accanto, in
 * chiaro — qui non cambia niente di quel principio, cambia solo il disegno
 * dentro il cerchio (`docs/DECISIONI.md`, BQ1: prima erano le iniziali).
 *
 * **Colore proprio, non `currentColor` puro.** Le altre icone di
 * `PlatformIcons.tsx`/`NavIcons.tsx` prendono il colore del testo accanto
 * apposta, perché quel testo è la loro etichetta. Qui non c'è un'etichetta
 * accanto che debba restare in tono: il cerchio ha un fondo colorato suo
 * (`--accent` o `--kpi-2`, dallo stile del contenitore, non da qui), e
 * l'icona prende comunque `currentColor` — che il contenitore fissa a
 * `--accent-ink`, lo stesso inchiostro già verificato per stare sopra un
 * fondo pieno (7,4:1 su `--accent`, 5,1:1 su `--kpi-2` in chiaro, sempre
 * sopra 8:1 in scuro: `docs/DECISIONI.md`, BQ1).
 */

/**
 * Il profilo di chi ha fatto accesso: la sagoma classica di una persona.
 *
 * Una prima ipotesi (un lumino, la luce per chi risponde a chi è nel buio)
 * è stata scartata dal proprietario alla prova: non si riconosce come "il
 * mio profilo" a colpo d'occhio, che è l'unico compito di questa icona
 * (`docs/DECISIONI.md`, BQ1).
 */
export function UserIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="8.5" r="3.75" />
      <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" />
    </Icon>
  );
}

/** L'ente: mani unite, non un edificio — qui conta chi ne fa parte, non dove sta. */
export function AssociationIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="8.5" cy="8" r="3" />
      <circle cx="16.5" cy="9" r="2.5" />
      <path d="M3.5 20v-1.5a5 5 0 0 1 5-5h0a5 5 0 0 1 5 5V20" />
      <path d="M14.2 12.7A4 4 0 0 1 20.5 16v2" />
    </Icon>
  );
}
